export const NOTIFICATION_PREFERENCES_REFRESH_EVENT =
  "reelitpro:notification-preferences-refresh";

export function requestNotificationPreferencesRefresh(windowObject = window) {
  windowObject?.dispatchEvent?.(
    new Event(NOTIFICATION_PREFERENCES_REFRESH_EVENT)
  );
}
